import { useQuery } from '@tanstack/react-query'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import {
  SERVICE_BOOKING_PATH,
  SERVICE_BOOKING_VERIFY_CODE_PATH,
} from '@/services'

export const useGetBookingRepairToken = (
  { tokenId, verifyCode, verifyLength, isArrivalConfirm, isBookingDetails },
  config = {},
) => {
  const api = useLegacyPublicApi()

  return useQuery({
    queryKey: ['get-booking-repair-token', tokenId, verifyCode],
    queryFn: async () => {
      if (!api || !tokenId) return false
      const isCodeVerification =
        !isArrivalConfirm && !isBookingDetails && verifyLength > 0
      if (isCodeVerification && verifyCode?.length !== verifyLength)
        return false
      const url = isCodeVerification
        ? SERVICE_BOOKING_VERIFY_CODE_PATH.replace(
            '{tokenId}',
            tokenId,
          ).replace('{verifyCode}', verifyCode)
        : SERVICE_BOOKING_PATH.replace('{tokenId}', tokenId)
      const { data } = await api.get(url)
      return data
    },
    staleTime: Infinity,
    retry: (failureCount, error) => {
      const serverErrorCode =
        error.response?.data?.length > 0 ? error.response.data[0].Code : 0
      if (serverErrorCode === 6092) {
        return false
      }
      return failureCount < 2
    },
    ...config,
  })
}
